import { render, staticRenderFns } from "./MainLayoutContainer.vue?vue&type=template&id=07de9bcd&"
import script from "./MainLayoutContainer.vue?vue&type=script&lang=js&"
export * from "./MainLayoutContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports